var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"results container",class:{'iphone': _vm.iOS}},[_c('FootnoteDisplay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }